export default "__VITE_ASSET__DlT66i5K__"